import React, {useEffect, useState} from 'react';
import {Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import {AddressInputVm} from "../components/input/address/Address";
import {MediaQueryTypes, useMediaQuery} from "../app/hooks";
import cn from "classnames";

interface AddressDropdownProps {
    addresses: readonly AddressInputVm[];
    onAddressSelected?: (address: AddressInputVm | null) => void;
}

const AddressDropdown: React.FC<AddressDropdownProps> = ({
                                                             addresses,
                                                             onAddressSelected: _onAddressSelected
                                                         }) => {
    
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const [isOpen, setIsOpen] = useState(() => addresses.length > 0);
    useEffect(() => {
        setIsOpen(addresses.length > 0);    
    }, [addresses]);
    
    const isMobile = useMediaQuery(MediaQueryTypes.IS_MOBILE);

    const dropdownMenuClassName = cn(
        'my-0',
        'py-0', {
        'w-100': isMobile,
        'w-75': !isMobile,
    });
    
    const dropdownItemClassName = cn(
        'border-bottom',
        'border-muted',
    )
    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (addresses.length === 0) return;

        switch (event.key) {
            case 'ArrowDown':
                setFocusedIndex((prevIndex) =>
                    prevIndex < addresses.length - 1 ? prevIndex + 1 : 0
                );
                break;
            case 'ArrowUp':
                setFocusedIndex((prevIndex) =>
                    prevIndex > 0 ? prevIndex - 1 : addresses.length - 1
                );
                break;
            case 'Enter':
                if (focusedIndex >= 0 && handleAddressClick) {
                    handleAddressClick(addresses[focusedIndex]);
                }
                break;
            default:
                break;
        }
    };

    const handleAddressClick = (addr: AddressInputVm) => {
        if (_onAddressSelected) {
            _onAddressSelected(addr);
        }
    }

    const handleHideSuggestionsClick = () => {
        setIsOpen(false);
        if (_onAddressSelected) {
            _onAddressSelected(null);
        }
    }
    
    function focusClass(index: number) {
        return focusedIndex === index ? 'active' : '';
    }

    return (
        <div className="">
            {addresses.length > 0 && (
                <Dropdown isOpen={isOpen}
                          onKeyDown={handleKeyDown}
                >
                    <DropdownMenu className={dropdownMenuClassName}>
                        <DropdownItem onClick={handleHideSuggestionsClick}
                                      className={dropdownItemClassName}>
                            Hide Suggestions
                        </DropdownItem>
                        {addresses.map((address, index) => (
                            <DropdownItem
                                key={address.id}
                                onMouseEnter={() => setFocusedIndex(index)}
                                onClick={() => handleAddressClick && handleAddressClick(address)}
                                className={`${focusClass(index)} ${dropdownItemClassName}`} 
                            >
                                <SuggestedAddressRow address={address}/>
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </Dropdown>
            )}
        </div>
    );
};

export default AddressDropdown;


interface SuggestedAddressRowProps {
    address: AddressInputVm;
}

export const SuggestedAddressRow: React.FC<SuggestedAddressRowProps> = ({address}) => {
    return (
        <div>
            <p className="py-0 my-0">{address.street}</p>
            <p className="py-0 my-0">
                {address.city}, {address.stateCode} {address.zip}
            </p>
        </div>
    );
};